import React, { useState, useEffect } from "react";
import Axios from '../../../../utils/api/axiosConf';
import { url } from '../../../../utils/api/api';
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import { useParams, useRevalidator, useSearchParams } from "react-router-dom";
import LOADING from "../../../../components/loading/loading";
import { Col, Radio, Row } from "antd";
import INPUT from '../../../../components/input/input';
import BUTTON from "../../../../components/buttons/button";
import { color } from "../../../../utils/themes/color";
import recycleImg from "./../../../../assets/images/recycleBin.jpg";
import CHECKBOX from "./../../../../components/checkBox";




export default function ClubsAndEquipmentsAthlete() {

    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('id');
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState([]);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState([]);

    const [clubs, setClubs] = useState([]);
    const [equipments, setEquipments] = useState([]);
    const [updator, setUpdator] = useState(1)

    useEffect(() => {
        Axios.get(`${url}sports-equipments/v1/search`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    var x = [];
                    for (const iterator of response.data.docs) {
                        x.push({
                            name: iterator.title,
                            value: iterator._id
                        })
                    }
                    setData(x)
                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updator])

    useEffect(() => {
        setLoading(true)
        Axios.get(`${url}users/get-athlete-sport-clubs-and-equipments/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setClubs(response.data.sportClubs)

                    if (response.data.sportsEquipments != null && response.data.sportsEquipments != undefined) {
                        var x = [];
                        for (const iterator of response.data.sportsEquipments) {
                            x.push(iterator)
                        }
                        setSelected(x)
                    }
                    setLoading(false)

                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log("er", error)
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updator])


    const updateClubsAndEquipment = () => {

       
            if (user.title != "" && user.title != null && user.title != undefined) {
                var x = [];
                for (const iterator of clubs) {
                    x.push(
                        { "title": iterator.title }
                    )
                }
                x.push(
                    { "title": user.title }
                )


                var l = {
                    "sportClubs": x,
                    "sportsEquipments": selected
                }



                setLoading(true)
                Axios.patch(`${url}users/athlete-sport-clubs-and-equipments/${userId}`, l)
                    .then(async (response) => {

                        if (response.status === 200 || response.status === 201) {
                            setUpdator(updator + 1)
                            GreenNotif(response.message);
                            setLoading(false)

                        } else {
                            RedNotif(response.message);
                            setLoading(false)
                        }
                    })
                    .catch((error) => {
                        RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                        console.log("error", error)
                        setLoading(false)
                    });

            } 
            else {
                setLoading(false)
                RedNotif("نام باشگاه نمیتواند خالی باشد")
            }
        

        setLoading(true);

    }


    const deleteClubs = (item) => {
        var x = [];

        clubs.filter(function (obj) {
            if (obj.title !== item.title) {
                x.push(obj)
            }
        });

        setClubs(x)

    }



    switch (loading) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row style={{ marginBottom: '18px' }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <p>نام باشگاه خود را وارد نمایید:</p>
                    </Col>
                </Row>


                <Row style={{ marginRight: '8px' }} gutter={20}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} style={{ marginBottom: '28px' }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>نام باشگاه:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <INPUT
                            placeholder="مثلا آسیا"
                            i={(e) => setUser({ ...user, "title": e })}
                            value={user.title != undefined && user.title != null && user.title != "0" ? user.title : ""}
                        />
                    </Col>

                </Row>

                <Row style={{ marginTop: '24px' }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} style={{ display: 'flex', justifyContent: 'center' }}>
                        <p style={{ color: color.secondary, fontWeight: 'bold', cursor: "pointer" }} onClick={(e) => updateClubsAndEquipment()}>افزودن</p>
                    </Col>
                </Row>

                <Row gutter={[8, 16]} style={{ marginTop: '32px' }} >
                    {clubs.map((item, index) =>
                        <Col offset={1} span={6} key={index} xxl={6} xl={6} lg={6} md={6} sm={6} style={{ border: `1px solid ${color.primary}`, background: "white", height: "48px" }}>

                            <Row style={{ marginRight: '18px' }}>
                                <Col xxl={22} xl={22} lg={22} md={22} sm={22} style={{ marginBottom: '16px', marginTop: '12px' }}>
                                    <p style={{ fontSize: "12px" }}>{item.title}</p>
                                </Col>
                                <Col xxl={2} xl={2} lg={2} md={2} sm={2} style={{ marginBottom: '28px', marginTop: '18px' }}>
                                    <img src={recycleImg} style={{ width: "50%", cursor: "pointer" }} onClick={() => deleteClubs(item)} />
                                </Col>
                            </Row>

                        </Col>
                    )}

                </Row>

                <br />
            
                 <Row style={{ marginRight: '8px' , marginTop: '32px'}}>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                                    <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                                        <p>تجهیزات:</p>
                                        <p style={{ color: color.mandatoryColor }}>*</p>                                    </div>
                                    <br />

                                    <CHECKBOX
                                        click={(e) => {
                                            var x = equipments;
                                            x.push(e)
                                            setEquipments(e)
                                        }}
                                        items={data}
                                        selectedItems={selected}
                                        check={(e) => { setSelected(e) }

                                        }
                                    />
                                </Col>
                 </Row>


                <Row style={{ marginTop: '42px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => updateClubsAndEquipment()} text="ثبت و بعدی" type={"submit"} loading={loading} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => window.location.reload()} text="رد کردن" type={"cancel"} />

                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }

}